<div id="logo" class="logo">
  <img [src]="welcomeLogoUrl" alt="Atout France" class="brand" />
</div>

<section (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave($event)">
  <video
    id="video"
    poster="./assets/video-preview.jpg"
    autoplay
    playsinline
    muted
    [muted]="mute"
    loop
    *ngIf="isTablet || isDesktop">
    <source [src]="video_source_dash" type="application/x-mpegURL" />
    <source [src]="video_source_webm" type="video/webm" />
    <source [src]="video_source_mp4" type="video/mp4" />
  </video>

  <div class="bg-image" *ngIf="isMobile" style="background-image: url('./assets/video-preview.jpg')">&nbsp;</div>

  <div *ngIf="isTablet">
    <div class="container-center-center">
      <button mat-button mat-raised-button color="primary" type="button" (click)="goLogin()">Explore Me</button>
    </div>
  </div>

  <div class="overlay" [@slideInOut]="backdropState">
    <div class="video-gradient"></div>
    <div class="video-pattern"></div>
  </div>

  <div class="controlbar" *ngIf="isDesktop || isTablet">
    <button mat-fab color="primary" aria-label="Example icon button with a delete icon" (click)="togglePlay()">
      <mat-icon>{{ playingIcon }}</mat-icon>
    </button>
    &nbsp;
    <button mat-fab color="accent" aria-label="Example icon button with a bookmark icon" (click)="toggleMute()">
      <mat-icon>{{ muteIcon }}</mat-icon>
    </button>
  </div>

  <div [@slideInOut]="animationState" (@slideInOut.done)="onDialogShown()" #contentform class="myForm">
    <section class="section-border border-primary" style="position: relative; z-index: 100">
      <div class="container d-flex flex-column">
        <div class="row align-items-center justify-content-center gx-0 min-vh-100">
          <div
            class="col-12 col-md-6 col-lg-{{ colLarge }} french-border-top
            col-xl-{{ colXLarge }} py-8 py-md-11 wrap mat-elevation-z4 myLoginForm">
            <mat-tab-group class="invisible-tabs" [(selectedIndex)]="activeTab">
              <mat-tab label="Welcome">
                <div class="example-small-box text-center">
                  <div class="welcome-logo" *ngIf="welcomeLogoUrl">
                    <img [src]="welcomeLogoUrl" alt="Atout France" class="welcome-brand" />
                  </div>
                  <!-- Heading -->
                  <h1 class="mb-0 text-center"><span [innerHTML]="__txt_Welcome"></span> {{ _eventYear }}</h1>

                  <!-- Text -->
                  <span [innerHTML]="__txt_Welcome_Text"></span>

                  <button mat-button mat-raised-button color="primary" type="button" (click)="goLogin()">Start</button>
                </div>
              </mat-tab>

              <!-- ---------------------------------------- LOGIN ------------------------------------ -->
              <mat-tab label="Login">
                <div class="example-small-box">
                  <!-- Heading -->
                  <h1 class="mb-0 text-center" style="font-size: 55px">Welcome</h1>

                  <!-- Text -->
                  <p class="mb-6 text-center text-muted">{{ __txt_subline }} {{ _eventYear }}</p>

                  <!-- Form -->
                  <form (ngSubmit)="login()" [formGroup]="loginForm" class="mb-3 login-form">
                    <!-- Email -->
                    <div class="form-group">
                      <label class="form-label" for="email"> E-Mail </label>
                      <input type="email" formControlName="email" id="email" class="form-control" required placeholder="name@address.com" />
                    </div>

                    <!-- Password -->
                    <div class="form-group mb-3">
                      <label class="form-label" for="password"> Password </label>
                      <input [type]="!eye ? 'password' : 'text'" formControlName="password" id="password" class="form-control" required />
                      <mat-icon class="field-icon toggle-password" style="padding-top: 10px" (click)="toggleEye()">{{ eyeIcon }}</mat-icon>
                    </div>

                    <!-- Submit -->
                    <div class="flex items-center justify-between">
                      <button mat-button mat-ripple class="btn-primary" type="submit">Sign In</button>

                      <button mat-button type="button" (click)="goForgot()">Forgot Password</button>
                    </div>
                  </form>

                  <p class="mb-0 fs-sm text-center text-muted">
                    <span (click)="showFirststart($event)">Don't</span> have an account yet
                    <button mat-button type="button" (click)="goSignup()">Register Now</button>
                  </p>
                </div>
              </mat-tab>

              <!-- ---------------------------------------- REGISTER NOW ------------------------------------ -->
              <mat-tab label="New Registration">
                <div class="example-large-box">
                  <div class="example-small-box">
                    <!-- Heading -->
                    <h1 class="mb-0 text-center">New Registration</h1>

                    <!-- Text -->
                    <p class="mb-6 text-center text-muted">Please fill out the form.</p>

                    <!-- Form -->
                    <form (ngSubmit)="register()" [formGroup]="registerForm" class="mb-3">
                      <!-- Company -->
                      <div class="form-group">
                        <label class="form-label" for="company"> Company *</label>
                        <input
                          type="text"
                          class="form-control"
                          id="company"
                          formControlName="company"
                          [ngClass]="{ 'is-invalid': submitted && registerForm.controls['company'].invalid }"
                          placeholder="Your Company" />
                        <div *ngIf="submitted && registerForm.controls['company'].invalid" class="error">Company is required</div>
                      </div>

                      <!-- Firstname -->
                      <div class="form-group">
                        <label class="form-label" for="firstname"> Firstname *</label>
                        <input
                          type="text"
                          class="form-control"
                          id="firstname"
                          formControlName="firstname"
                          [ngClass]="{ 'is-invalid': submitted && registerForm.controls['firstname'].invalid }"
                          placeholder="Your Firstname" />
                        <div *ngIf="submitted && registerForm.controls['firstname'].invalid" class="error">Firstname is required</div>
                      </div>

                      <!-- Lastname -->
                      <div class="form-group">
                        <label class="form-label" for="lastname"> Lastname *</label>
                        <input
                          type="text"
                          class="form-control"
                          id="lastname"
                          formControlName="lastname"
                          [ngClass]="{ 'is-invalid': submitted && registerForm.controls['lastname'].invalid }"
                          placeholder="Your Lastname" />
                        <div *ngIf="submitted && registerForm.controls['lastname'].invalid" class="error">Lastname is required</div>
                      </div>

                      <!-- Position -->
                      <div class="form-group">
                        <label class="form-label" for="position"> Position *</label>
                        <input
                          type="text"
                          class="form-control"
                          id="position"
                          formControlName="position"
                          [ngClass]="{ 'is-invalid': submitted && registerForm.controls['position'].invalid }"
                          placeholder="Your Position" />
                        <div *ngIf="submitted && registerForm.controls['position'].invalid" class="error">Position is required</div>
                      </div>

                      <!-- E-Mail -->
                      <div class="form-group">
                        <label class="form-label" for="email"> E-Mail *</label>
                        <input
                          type="text"
                          class="form-control"
                          id="email"
                          formControlName="email"
                          [ngClass]="{ 'is-invalid': submitted && registerForm.controls['email'].invalid }"
                          placeholder="name@email.com" />
                        <div *ngIf="submitted && registerForm.controls['email'].invalid" class="error">E-Mail is required</div>
                      </div>

                      <!-- Country -->
                      <div class="form-group">
                        <label class="form-label" for="email"> Country *</label>

                        <select
                          class="form-control"
                          id="country"
                          formControlName="country"
                          [ngClass]="{ 'is-invalid': submitted && registerForm.controls['country'].invalid }">
                          <option value="at">Austria</option>
                          <option value="ba">Bosnia-Herzegovina</option>
                          <option value="bg">Bulgaria</option>
                          <option value="hr">Croatia</option>
                          <option value="cz">Czech Republic</option>
                          <option value="fr">France</option>
                          <option value="de">Germany</option>
                          <option value="hu">Hungary</option>
                          <option value="xk">Kosovo</option>
                          <option value="mk">Macedonia</option>
                          <option value="mne">Montenegro</option>
                          <option value="pl">Poland</option>
                          <option value="ro">Romania</option>
                          <option value="xs">Serbia</option>
                          <option value="sk">Slovakia</option>
                          <option value="si">Slovenia</option>
                          <option value="ch">Switzerland</option>
                        </select>
                        <div *ngIf="submitted && registerForm.controls['country'].invalid" class="error">Country is required</div>
                      </div>

                      <!-- exhibitor - visitor -->
                      <div class="form-group">
                        <label class="form-label" for="exhibitor"> I am coming as *</label>
                        <div class="flex items-center">
                          <input
                            id="exhibitor"
                            formControlName="role"
                            type="radio"
                            value="exhibitor"
                            checked
                            class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                          <label for="exhibitor" class="ml-3 block text-sm font-medium text-gray-700">Exhibitor</label>
                        </div>

                        <div class="flex items-center">
                          <input
                            id="visitor"
                            formControlName="role"
                            type="radio"
                            value="visitor"
                            class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                          <label for="visitor" class="ml-3 block text-sm font-medium text-gray-700">Visitor</label>
                        </div>
                      </div>

                      <!-- Submit -->
                      <button mat-button class="btn w-100 btn-primary" type="submit">Register Now</button>

                      <button mat-button type="button" (click)="goLogin()">back</button>
                    </form>
                  </div>
                </div>
              </mat-tab>

              <!-- ---------------------------------------- FORGOT PASSWORD ------------------------------------ -->

              <mat-tab label="Forgot Password">
                <div class="example-large-box">
                  <!-- Heading -->
                  <h1 class="mb-0 text-center">Forgot Password</h1>

                  <!-- Text -->
                  <p class="mb-6 text-center text-muted">Fill out the form.</p>
                  <form (ngSubmit)="forgot()" [formGroup]="forgotForm">
                    <div class="mb-3">
                      <label for="email" class="form-label">Email</label>
                      <input type="email" id="email" class="form-control" name="email" placeholder="Enter Your Email" required="" />
                    </div>
                    <div class="mb-3">
                      <button mat-button mat-ripple type="submit" class="btn-primary">Reset Password</button>
                    </div>
                    <span>Don't have an account? <button mat-button type="button" (click)="goSignup()">Register Now</button></span>
                  </form>
                  <button mat-button type="button" (click)="goLogin()">back</button>
                </div>
              </mat-tab>

              <!-- ---------------------------------------- FIRSTSTART ASSISTANT EXHIBITOR ------------------------------------ -->

              <mat-tab label="Firststart">
                <div class="example-large-box">
                  <!-- Heading -->

                  <!-- no admin tab - as this is only seen by the exhibitor
                    the admin tab is in profile-exhibitor
                  -->

                  <form [formGroup]="firstExhibitorForm">
                    <mat-horizontal-stepper #stepper labelPosition="bottom" (selectionChange)="setIndex($event)" (click)="triggerClick()">
                      <mat-step label="Société">
                        <div class="step-container d-flex align-items-start flex-column">
                          <div class="container-fluid">
                            <div class="form">
                              <div class="grid gap-6 mb-6 md:grid-cols-2">
                                <div>
                                  <label for="adresse" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >Adresse *</label
                                  >
                                  <input
                                    type="text"
                                    id="adresse"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder=""
                                    formControlName="adresse"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['adresse'].invalid }" />
                                  <div *ngIf="submitted && firstExhibitorForm.controls['adresse'].invalid" class="error">
                                    Adresse is required
                                  </div>
                                </div>

                                <div>
                                  <label for="plz" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">CP *</label>
                                  <input
                                    type="text"
                                    id="plz"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder=""
                                    formControlName="plz"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['plz'].invalid }" />
                                  <div *ngIf="submitted && firstExhibitorForm.controls['plz'].invalid" class="error">CP is required</div>
                                </div>
                                <div>
                                  <label for="stadt" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Ville *</label>
                                  <input
                                    type="text"
                                    id="stadt"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder=""
                                    formControlName="stadt"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['stadt'].invalid }" />
                                  <div *ngIf="submitted && firstExhibitorForm.controls['stadt'].invalid" class="error">
                                    Ville is required
                                  </div>
                                </div>
                                <div>
                                  <label for="phone" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >Téléphone *</label
                                  >
                                  <input
                                    type="text"
                                    id="telefon"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder=""
                                    formControlName="telefon"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['telefon'].invalid }" />
                                  <div *ngIf="submitted && firstExhibitorForm.controls['telefon'].invalid" class="error">
                                    Téléphone is required
                                  </div>
                                </div>
                                <div>
                                  <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >Company E-Mail *</label
                                  >
                                  <input
                                    type="text"
                                    id="email"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder=""
                                    formControlName="email"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['email'].invalid }" />
                                  <div *ngIf="submitted && firstExhibitorForm.controls['email'].invalid" class="error">
                                    Company E-Mail is required
                                  </div>
                                </div>
                                <div>
                                  <label for="website" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >Site web *</label
                                  >
                                  <input
                                    type="text"
                                    id="web"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder=""
                                    formControlName="web"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['web'].invalid }" />
                                  <div *ngIf="submitted && firstExhibitorForm.controls['web'].invalid" class="error">
                                    Website is required
                                  </div>
                                </div>

                                <div>
                                  <label for="taxid_uid" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >N° de TVA intracomm *</label
                                  >
                                  <input
                                    type="text"
                                    id="taxid_uid"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder=""
                                    formControlName="taxid_uid"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['taxid_uid'].invalid }" />
                                  <div *ngIf="submitted && firstExhibitorForm.controls['taxid_uid'].invalid" class="error">
                                    N° de TVA intracomm is required
                                  </div>
                                </div>
                                <div>
                                  <label for="website" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >Catégorie *</label
                                  >
                                  <select
                                    id="category"
                                    name="category"
                                    formControlName="category"
                                    class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['category'].invalid }">
                                    <option *ngFor="let category of EVENT_CATEGORIES" [value]="category">
                                      {{ category }}
                                    </option>
                                  </select>
                                  <!--
                                  <select
                                    id="category"
                                    name="category"
                                    formControlName="category"
                                    class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                    [ngClass]="{ 'is-invalid': submitted && firstExhibitorForm.controls['category'].invalid }">
                                    <option value="Accommodation" selected>Accommodation</option>
                                    <option value="Boating Holidays">Boating Holidays</option>
                                    <option value="Carriers">Carriers</option>
                                    <option value="Cultural Sites">Cultural Sites</option>
                                    <option value="Excursions / Entertainment">Excursions</option>
                                    <option value="Incoming services">Incoming services</option>
                                    <option value="Luxury offers">Luxury offers</option>
                                    <option value="MICE Services">MICE Services</option>
                                    <option value="Ski">Ski</option>
                                    <option value="Tourist offices">Tourist offices</option>
                                    <option value="Shopping">Shopping</option>
                                    <option value="Others">Others</option>
                                  </select>
                                  -->
                                  <div *ngIf="submitted && firstExhibitorForm.controls['category'].invalid" class="error">
                                    Catégorie is required
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="step-footer">
                          <button mat-raised-button matStepperNext color="primary">Next</button>
                        </div>
                      </mat-step>

                      <mat-step label="Région">
                        <div class="step-container d-flex align-items-start flex-column">
                          <div class="container-fluid">
                            <div class="form">
                              <div class="row">
                                <div>
                                  <p class="font-semibold">Veuillez remplir les informations sur la région.</p>
                                </div>

                                <div class="grid gap-6 mb-6 mt-6 md:grid-cols-2" formGroupName="regionsGroup">
                                  <div class="flex items-center">
                                    <input id="auvergne" formControlName="auvergne" type="checkbox" class="form-check-input" />
                                    <label for="auvergne" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Auvergne-Rhône-Alpes</label
                                    >
                                  </div>

                                  <div class="flex items-center">
                                    <input id="bourgogne" formControlName="bourgogne" type="checkbox" class="form-check-input" />
                                    <label for="bourgogne" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Bourgogne-Franche-Comté</label
                                    >
                                  </div>
                                  <div class="flex items-center">
                                    <input id="bretagne" formControlName="bretagne" type="checkbox" class="form-check-input" />
                                    <label for="bretagne" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Bretagne</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="centreloire" formControlName="centreloire" type="checkbox" class="form-check-input" />
                                    <label for="centreloire" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Centre-Val de Loire</label
                                    >
                                  </div>

                                  <div class="flex items-center">
                                    <input id="corse" formControlName="corse" type="checkbox" class="form-check-input" />
                                    <label for="corse" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Corse</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="champagne" formControlName="champagne" type="checkbox" class="form-check-input" />
                                    <label for="champagne" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Grand Est</label
                                    >
                                  </div>
                                  <div class="flex items-center">
                                    <input id="nordcalais" formControlName="nordcalais" type="checkbox" class="form-check-input" />
                                    <label for="nordcalais" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Hauts-de-France</label
                                    >
                                  </div>
                                  <div class="flex items-center">
                                    <input id="normandie" formControlName="normandie" type="checkbox" class="form-check-input" />
                                    <label for="normandie" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Normandie</label
                                    >
                                  </div>

                                  <div class="flex items-center">
                                    <input id="aquitaine" formControlName="aquitaine" type="checkbox" class="form-check-input" />
                                    <label for="aquitaine" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Nouvelle-Aquitaine</label
                                    >
                                  </div>
                                  <div class="flex items-center">
                                    <input id="languedoc" formControlName="languedoc" type="checkbox" class="form-check-input" />
                                    <label for="languedoc" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Occitanie</label
                                    >
                                  </div>
                                  <div class="flex items-center">
                                    <input id="outremer" formControlName="outremer" type="checkbox" class="form-check-input" />
                                    <label for="outremer" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Outre-mer</label
                                    >
                                  </div>
                                  <div class="flex items-center">
                                    <input id="paris" formControlName="paris" type="checkbox" class="form-check-input" />
                                    <label for="paris" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Paris Île-de-France</label
                                    >
                                  </div>

                                  <div class="flex items-center">
                                    <input id="paysloire" formControlName="paysloire" type="checkbox" class="form-check-input" />
                                    <label for="paysloire" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Pays de la Loire</label
                                    >
                                  </div>
                                  <div class="flex items-center">
                                    <input id="paca" formControlName="paca" type="checkbox" class="form-check-input" />
                                    <label for="paca" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >Provence-Alpes-Côte d'Azur</label
                                    >
                                  </div>
                                  <div class="flex items-center">
                                    <input id="multiregions" formControlName="multiregions" type="checkbox" class="form-check-input" />
                                    <label for="multiregions" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                      >France entière</label
                                    >
                                  </div>

                                  <!-- dynamic fields regions requested  -->
                                  <ng-container *ngFor="let key of getKeysRegions(); let i = index">
                                    <div *ngIf="show_dyn_regions_ex[i]" class="flex items-center">
                                      <input [id]="key" [formControlName]="key" type="checkbox" class="form-check-input" />
                                      <label [for]="key" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        {{ caption_dyn_regions_ex[key] }}
                                      </label>
                                    </div>
                                  </ng-container>
                                  <!-- end dyn fields -->

                                  <div *ngIf="submitted && firstExhibitorForm.controls['regionsGroup'].invalid" class="error mb-3">
                                    <p>At least one box is required to check.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="step-footer">
                          <button mat-raised-button matStepperPrevious>Back</button> &nbsp;
                          <button mat-raised-button matStepperNext color="primary">Next</button>
                        </div>
                      </mat-step>

                      <mat-step label="Activité">
                        <div class="step-container d-flex align-items-start flex-column">
                          <div class="container-fluid">
                            <div class="form">
                              <div class="row">
                                <div>
                                  <p class="font-semibold">Veuillez remplir les informations sur l'activité.</p>
                                </div>

                                <div class="grid gap-6 mb-6 mt-6 md:grid-cols-2" formGroupName="activitiesGroup">
                                  <div class="flex items-center">
                                    <input
                                      id="agencereceptive"
                                      formControlName="agencereceptive"
                                      type="checkbox"
                                      class="form-check-input" />
                                    <label for="agencereceptive" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[0]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input
                                      id="centralereservation"
                                      formControlName="centralereservation"
                                      type="checkbox"
                                      class="form-check-input" />
                                    <label for="centralereservation" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[1]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="destination" formControlName="destination" type="checkbox" class="form-check-input" />
                                    <label for="destination" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[2]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="excursion" formControlName="excursion" type="checkbox" class="form-check-input" />
                                    <label for="excursion" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[3]
                                    }}</label>
                                  </div>

                                  <div class="flex items-center">
                                    <input id="groupement" formControlName="groupement" type="checkbox" class="form-check-input" />
                                    <label for="groupement" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[4]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input
                                      id="locationfluviale"
                                      formControlName="locationfluviale"
                                      type="checkbox"
                                      class="form-check-input" />
                                    <label for="locationfluviale" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[5]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="musee" formControlName="musee" type="checkbox" class="form-check-input" />
                                    <label for="musee" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[6]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="transporteur" formControlName="transporteur" type="checkbox" class="form-check-input" />
                                    <label for="transporteur" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[12]
                                    }}</label>
                                  </div>

                                  <div class="flex items-center">
                                    <input id="autre" formControlName="autre" type="checkbox" class="form-check-input" />
                                    <label for="autre" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[13]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="offreski" formControlName="offreski" type="checkbox" class="form-check-input" />
                                    <label for="offreski" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[7]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="ski_station" formControlName="ski_station" type="checkbox" class="form-check-input" />
                                    <label for="ski_station" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[8]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="ski_rental" formControlName="ski_rental" type="checkbox" class="form-check-input" />
                                    <label for="ski_rental" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[9]
                                    }}</label>
                                  </div>

                                  <div class="flex items-center">
                                    <input
                                      id="residencetourisme"
                                      formControlName="residencetourisme"
                                      type="checkbox"
                                      class="form-check-input" />
                                    <label for="residencetourisme" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[10]
                                    }}</label>
                                  </div>
                                  <div class="flex items-center">
                                    <input id="restaurant" formControlName="restaurant" type="checkbox" class="form-check-input" />
                                    <label for="restaurant" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{
                                      activities_fr[11]
                                    }}</label>
                                  </div>

                                  <!-- dynamic fields activities requested  -->
                                  <ng-container *ngFor="let key of getKeysActivities(); let i = index">
                                    <div *ngIf="show_dyn_activities_ex[i]" class="flex items-center">
                                      <input [id]="key" [formControlName]="key" type="checkbox" class="form-check-input" />
                                      <label [for]="key" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        {{ caption_dyn_activities_ex[key] }}
                                      </label>
                                    </div>
                                  </ng-container>
                                  <!-- end dyn fields -->

                                  <div *ngIf="submitted && firstExhibitorForm.controls['activitiesGroup'].invalid" class="error mb-3">
                                    <p>At least one box is required to check.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="step-footer">
                          <button mat-raised-button matStepperPrevious>Back</button> &nbsp;
                          <button mat-raised-button matStepperNext color="primary">Next</button>
                        </div>
                      </mat-step>

                      <mat-step label="Offre">
                        <div class="step-container d-flex align-items-start flex-column">
                          <div class="container-fluid">
                            <div class="row mb-6 mt-6">
                              <label for="beschreibung" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >Descriptif de votre activité / offre</label
                              >
                              <textarea
                                id="beschreibung"
                                formControlName="beschreibung"
                                rows="4"
                                class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder=""></textarea>
                              <div *ngIf="submitted && firstExhibitorForm.controls['beschreibung'].invalid" class="error">
                                Descriptif de votre activité / offre is required
                              </div>
                            </div>

                            <div class="row mb-6 mt-6">
                              <label for="info1" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Nouveautés</label>
                              <textarea
                                id="info1"
                                formControlName="info1"
                                rows="4"
                                class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder=""></textarea>
                              <div *ngIf="submitted && firstExhibitorForm.controls['info1'].invalid" class="error">
                                Nouveautés is required
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="step-footer">
                          <button mat-raised-button matStepperPrevious>Back</button> &nbsp;
                          <button mat-raised-button matStepperNext color="primary">Next</button>
                        </div>
                      </mat-step>

                      <mat-step label="Images">
                        <div class="step-container">
                          <div class="p-4">

                            <!-- Row 1: Profile photo + Company Logo -->
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

                              <!-- Profile photo -->
                              <div>
                                <label class="block mb-2 text-sm font-semibold text-gray-700">Votre photo de profil</label>
                                <file-pond
                                  id="myPondProfile"
                                  name="myPondProfile"
                                  [options]="pondOptions"
                                  [files]="pondFiles"
                                  (oninit)="pondHandleInit()"
                                  (onaddfile)="pondHandleAddFile($event)"
                                  (onactivatefile)="pondHandleActivateFile($event)">
                                </file-pond>
                                <img
                                  *ngIf="_profile_image"
                                  class="mt-3 h-32 w-auto rounded-lg object-cover border border-gray-200"
                                  src="{{ imageStorage }}{{ _profile_image }}"
                                  alt="Profile" />
                              </div>

                              <!-- Company logo -->
                              <div>
                                <label class="block mb-2 text-sm font-semibold text-gray-700">Your Company Logo</label>
                                <file-pond
                                  id="myPondLogo"
                                  name="myPondLogo"
                                  [options]="pondOptions"
                                  [files]="pondFiles"
                                  (oninit)="pondHandleInit()"
                                  (onaddfile)="pondHandleAddFile($event)"
                                  (onactivatefile)="pondHandleActivateFile($event)">
                                </file-pond>
                                <img
                                  *ngIf="_logo"
                                  class="mt-3 h-32 w-auto rounded-lg object-cover border border-gray-200"
                                  src="{{ imageStorage }}{{ _logo }}"
                                  alt="Logo" />
                              </div>
                            </div>

                            <!-- Row 2: Image 1 / Image 2 / Image 3 -->
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">

                              <!-- Image 1 -->
                              <div>
                                <label class="block mb-2 text-sm font-semibold text-gray-700">Image 1</label>
                                <file-pond
                                  id="myPondImage1"
                                  name="myPondImage1"
                                  [options]="pondOptions"
                                  [files]="pondFiles"
                                  (oninit)="pondHandleInit()"
                                  (onaddfile)="pondHandleAddFile($event)"
                                  (onactivatefile)="pondHandleActivateFile($event)">
                                </file-pond>
                                <img
                                  *ngIf="_bild1"
                                  class="mt-3 h-28 w-full rounded-lg object-cover border border-gray-200"
                                  src="{{ imageStorage }}{{ _bild1 }}"
                                  alt="Image 1" />
                              </div>

                              <!-- Image 2 -->
                              <div>
                                <label class="block mb-2 text-sm font-semibold text-gray-700">Image 2</label>
                                <file-pond
                                  id="myPondImage2"
                                  name="myPondImage2"
                                  [options]="pondOptions"
                                  [files]="pondFiles"
                                  (oninit)="pondHandleInit()"
                                  (onaddfile)="pondHandleAddFile($event)"
                                  (onactivatefile)="pondHandleActivateFile($event)">
                                </file-pond>
                                <img
                                  *ngIf="_bild2"
                                  class="mt-3 h-28 w-full rounded-lg object-cover border border-gray-200"
                                  src="{{ imageStorage }}{{ _bild2 }}"
                                  alt="Image 2" />
                              </div>

                              <!-- Image 3 -->
                              <div>
                                <label class="block mb-2 text-sm font-semibold text-gray-700">Image 3</label>
                                <file-pond
                                  id="myPondImage3"
                                  name="myPondImage3"
                                  [options]="pondOptions"
                                  [files]="pondFiles"
                                  (oninit)="pondHandleInit()"
                                  (onaddfile)="pondHandleAddFile($event)"
                                  (onactivatefile)="pondHandleActivateFile($event)">
                                </file-pond>
                                <img
                                  *ngIf="_bild3"
                                  class="mt-3 h-28 w-full rounded-lg object-cover border border-gray-200"
                                  src="{{ imageStorage }}{{ _bild3 }}"
                                  alt="Image 3" />
                              </div>
                            </div>

                            <!-- Row 3: Image Video + Presentation Video (Evening) -->
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                              <div>
                                <label class="block mb-2 text-sm font-semibold text-gray-700">Image Video</label>
                                <file-pond
                                  id="myPondImageVideo"
                                  name="myPondImageVideo"
                                  [options]="pondOptionsVideo"
                                  [files]="pondFiles"
                                  (oninit)="pondHandleInit()"
                                  (onaddfile)="pondHandleAddFile($event)"
                                  (onactivatefile)="pondHandleActivateFile($event)">
                                </file-pond>
                                <ng-container *ngIf="_imagevideo">
                                  <video class="mt-3 rounded-lg border border-gray-200" width="240" height="auto" controls>
                                    <source [src]="imageStorage + 'ivideos/' + _imagevideo" [type]="getMimeType(_imagevideo)" />
                                  </video>
                                </ng-container>
                              </div>
                              <div>
                                <label class="block mb-2 text-sm font-semibold text-gray-700">Presentation Video (Evening)</label>
                                <file-pond
                                  id="myPondPresentationVideo"
                                  name="myPondPresentationVideo"
                                  [options]="pondOptionsVideo"
                                  [files]="pondFiles"
                                  (oninit)="pondHandleInit()"
                                  (onaddfile)="pondHandleAddFile($event)"
                                  (onactivatefile)="pondHandleActivateFile($event)">
                                </file-pond>
                                <ng-container *ngIf="_presentationvideo">
                                  <video class="mt-3 rounded-lg border border-gray-200" width="240" height="auto" controls>
                                    <source [src]="imageStorage + 'evideos/' + _presentationvideo" [type]="getMimeType(_presentationvideo)" />
                                  </video>
                                </ng-container>
                              </div>
                            </div>

                            <div class="step-footer">
                              <button mat-raised-button matStepperPrevious>Back</button> &nbsp;
                              <button mat-raised-button matStepperNext color="primary">Next</button>
                            </div>

                              <!--
                              <ng-container *ngIf="_client === 'workshop-france'; else otherClient">
                                <div *ngIf="submitted && firstExhibitorForm.invalid" class="error">Please check the mandatory fields.</div>
                                <p>&nbsp;</p>
                                <div class="step-footer">
                                  <button mat-raised-button matStepperPrevious>Back</button> &nbsp;
                                  <button mat-raised-button (click)="submitFirststart()" color="primary">Submit</button>
                                </div>
                              </ng-container>

                              <ng-template #otherClient>
                                <button mat-raised-button matStepperPrevious>Back</button> &nbsp;
                                <button mat-raised-button matStepperNext color="primary">Next</button>
                              </ng-template>
                              -->
                          </div>
                        </div>
                      </mat-step>

                      <mat-step label="Logistique">
                        <div class="step-container d-flex align-items-start flex-column">
                          <div class="container-fluid">
                            <div class="form">
                              <div class="row">
                                <div class="grid gap-6 mb-6 md:grid-cols-2">
                                  <!-- passport -->
                                  <div class="form-group">
                                    <label class="form-label" for="passport"> Numéro de carte d'identité (passeport)</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="passport"
                                      formControlName="passport"
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                      placeholder="" />
                                  </div>

                                  <!-- birthdate -->
                                  <div class="form-group">
                                    <label class="form-label" for="birthdate"> Date de naissance</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="birthdate"
                                      formControlName="birthdate"
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                      placeholder="" />
                                  </div>

                                  <!-- linkedin -->
                                  <div class="form-group">
                                    <label class="form-label" for="linkedin"> LinkedIn</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="linkedin"
                                      formControlName="linkedin"
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                      placeholder="" />
                                  </div>

                                  <!-- hashtag -->
                                  <div class="form-group">
                                    <label class="form-label" for="hashtag"> Hashtag</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="hashtag"
                                      formControlName="hashtag"
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                      placeholder="" />
                                  </div>

                                  <!-- allergies -->
                                  <div class="form-group">
                                    <label class="form-label" for="allergies"> Allergies</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="allergies"
                                      formControlName="allergies"
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                      placeholder="" />
                                  </div>

                                  <!-- nahrungsmittelunvertraglichkeit / food intolerance -->
                                  <div class="form-group">
                                    <label class="form-label" for="nahrungsmittelunvertraglichkeit"> Intolérance alimentaires</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="nahrungsmittelunvertraglichkeit"
                                      formControlName="nahrungsmittelunvertraglichkeit"
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                      placeholder="" />
                                  </div>

                                  <!-- langulage_guide -->
                                  <div class="form-group">
                                    <label class="form-label" for="langulage_guide">
                                      Quelle(s) langue(s) acceptez-vous pour les visites guidées?</label
                                    >

                                    <select
                                      class="form-control"
                                      id="langulage_guide"
                                      formControlName="langulage_guide"
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                      <option value="1">Allemand</option>
                                      <option value="2">Anglais</option>
                                      <option value="3">Français</option>
                                      <option value="4">Allemand, Français</option>
                                      <option value="5">Anglais, Français</option>
                                      <option value="6">Allemand, Anglais</option>
                                      <option value="7">Français, Anglais, Allemand</option>
                                    </select>
                                  </div>

                                  <!-- zielgruppe_angebote -->
                                  <div class="form-group">
                                    <label class="form-label" for="zielgruppe_angebote"> Notre groupe cible</label>

                                    <input
                                      type="text"
                                      class="form-control"
                                      id="zielgruppe_angebote"
                                      formControlName="zielgruppe_angebote"
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                      placeholder="" />
                                  </div>
                                </div>
                              </div>

                              <!-- arrival -->
                              <div class="grid gap-6 mb-6 md:grid-cols-2">
                                <div>
                                  <h2 class="text-base/7 font-semibold text-gray-900">Arrivée</h2>
                                </div>
                                <div>&nbsp;</div>

                                <!-- type_anreise -->
                                <div class="form-group">
                                  <label class="form-label" for="type_anreise"> Je viens par</label>
                                  <select
                                    class="form-control"
                                    id="type_anreise"
                                    formControlName="type_anreise"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                    <option value="Zug">Train</option>
                                    <option value="Flug">Avion</option>
                                    <option value="Auto">Voiture</option>
                                  </select>
                                </div>
                                <!-- departure_location
                                <div class="form-group">
                                  <label class="form-label" for="departure_location"> Ort der Abreise</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="departure_location"
                                    formControlName="departure_location"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="" />
                                </div>
                                <!-- arrival_departure_time
                                <div class="form-group">
                                  <label class="form-label" for="arrival_departure_time"> Uhrzeit der Abreise</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="arrival_departure_time"
                                    formControlName="arrival_departure_time"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="" />
                                </div>
                                <!-- arrival_time -->
                                <div class="form-group">
                                  <label class="form-label" for="arrival_time"> Heure d'arrivée prévue</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="arrival_time"
                                    formControlName="arrival_time"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="" />
                                </div>
                                <!-- arrival_plane_selber
                                <div class="flex items-center">
                                  <input
                                    id="arrival_plane_selber"
                                    formControlName="arrival_plane_selber"
                                    type="checkbox"
                                    class="form-check-input" />
                                  <label for="arrival_plane_selber" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                    >Plane die Anreise selbst</label
                                  >
                                </div>
                                <!-- arrival_plane_atout
                                <!-- parking_space -->
                                <div class="flex items-center">
                                  <input id="parking_space" formControlName="parking_space" type="checkbox" class="form-check-input" />
                                  <label for="parking_space" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                    >J'ai besoin d'une place de parking</label
                                  >
                                </div>

                                <!-- arrival_day_before -->
                                <div class="flex items-center">
                                  <input
                                    id="arrival_day_before"
                                    formControlName="arrival_day_before"
                                    type="checkbox"
                                    class="form-check-input" />
                                  <label for="arrival_day_before" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                    >Je viens la veille ({{ _arrival_day_before_date || '14.10.2025' }}) (la nuitée du 29 au 30.09 est à votre charge organisationnelle et financière)</label
                                  >
                                </div>
                              </div>
                              <!-- end  -->

                              <!-- departure -
                              <div class="grid gap-6 mb-6 md:grid-cols-2">
                                <h2 class="text-base/7 font-semibold text-gray-900">Abreise</h2>
                                <div>&nbsp;</div>

                                <!-- departure_type_departure -
                                <div class="form-group">
                                  <label class="form-label" for="departure_type_departure"> Ich reise zur&uuml;ck mit</label>
                                  <select
                                    class="form-control"
                                    id="departure_type_departure"
                                    formControlName="departure_type_departure"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
<option value="Zug">Train</option>
                                    <option value="Flug">Avion</option>
                                    <option value="Auto">Voiture</option>
                                                                    </select>
                                </div>
                                <!-- departure_time --
                                <div class="form-group">
                                  <label class="form-label" for="departure_time"> Uhrzeit der Rückreise</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="departure_time"
                                    formControlName="departure_time"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="" />
                                </div>
                                <!-- departure_plane_selber --
                                <div class="flex items-center">
                                  <input
                                    id="departure_plane_selber"
                                    formControlName="departure_plane_selber"
                                    type="checkbox"
                                    class="form-check-input" />
                                  <label for="departure_plane_selber" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                    >Plane die Rückreise selbst</label
                                  >
                                </div>
                              </div>
                              <!-- end  -->

                              <!-- post_event
                              <div class="grid gap-6 mb-6 md:grid-cols-2">
                                <h2 class="text-base/7 font-semibold text-gray-900">Post-Event Aktion</h2>
                                <div>&nbsp;</div>

                                <!-- participate
                                <div class="form-group">
                                  <label class="form-label" for="participate"> Teilnahme</label>
                                  <select
                                    class="form-control"
                                    id="participate"
                                    formControlName="participate"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                    <option value="Nein">Nein</option>
                                  <option value="1">Nr. 1 Authentisches Burgund: Dijon und Umgebung - zwischen Geschichte, Weinbergern und Gastronomie</option>
                                  <option value="2">Nr. 2 Besancon und Dole - erleben, genießen, teilen</option>
                                  </select>
                                </div>
                                <!-- haftungsfreistellung
                                <div>&nbsp;</div>
                                <div class="flex items-center">
                                  <input
                                    id="haftungsfreistellung"
                                    formControlName="haftungsfreistellung"
                                    type="checkbox"
                                    class="form-check-input" />
                                  <label for="haftungsfreistellung" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                    Haftungsfreistellung
                                  </label>
                                </div>
                                <div>
                                  <p>
                                    Bei Teilnahme an Post-Tour bitte die
                                    <a
                                      class="text-blue-600 underline hover:text-blue-800"
                                      target="_blank"
                                      [href]="json?.post_event?.link_form"
                                      >Haftungsfreistellung</a
                                    >
                                    herunterladen, unterschreiben und per E-Mail an Atout-France senden.
                                  </p>
                                </div>
                              </div>
                              <!-- end  -->

                              <!-- event -->
                              <div class="grid gap-6 mb-6 md:grid-cols-2">
                                <h2 class="text-base/7 font-semibold text-gray-900">Evénement</h2>
                                <div>&nbsp;</div>

                                <!-- lunches: config-driven (one per lunch_dates entry) -->
                                <div class="form-group" *ngIf="_lunch_dates && _lunch_dates.length; else exLunchFallback">
                                  <div class="flex items-center" *ngFor="let d of _lunch_dates; let i = index">
                                    <input [id]="'lunch' + (i + 1)" [formControlName]="'lunch' + (i + 1)" type="checkbox" class="form-check-input" />
                                    <label [for]="'lunch' + (i + 1)" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                      Je participe au déjeuner - {{ d }}
                                    </label>
                                  </div>
                                </div>

                                <ng-template #exLunchFallback>
                                  <div class="form-group">
                                    <!-- lunch tag 1 -->
                                    <div class="flex items-center">
                                      <input id="lunch1" formControlName="lunch1" type="checkbox" class="form-check-input" />
                                      <label for="lunch1" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        Je participe au déjeuner - 15.10.2025
                                      </label>
                                    </div>
                                    <!-- lunch tag 2 -->
                                    <div class="flex items-center">
                                      <input id="lunch2" formControlName="lunch2" type="checkbox" class="form-check-input" />
                                      <label for="lunch2" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        Je participe au déjeuner - 16.10.2025
                                      </label>
                                    </div>
                                    <!-- lunch tag 3 -->
                                    <div class="flex items-center">
                                      <input id="lunch3" formControlName="lunch3" type="checkbox" class="form-check-input" />
                                      <label for="lunch3" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        Je participe au déjeuner - 17.10.2025
                                      </label>
                                    </div>
                                  </div>
                                </ng-template>

                                <!-- Nîmes guided visit (optional) -->
                                <div class="form-group" *ngIf="_nimes_visit_label">
                                  <div class="flex items-center">
                                    <input id="nimes_visit" formControlName="nimes_visit" type="checkbox" class="form-check-input" />
                                    <label for="nimes_visit" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                      {{ _nimes_visit_label }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <!-- end  -->
                            </div>
                          </div>
                        </div>

                        <div class="step-footer">
                          <button mat-raised-button matStepperPrevious>Back</button> &nbsp;
                          <button mat-raised-button matStepperNext color="primary">Next</button>
                        </div>
                      </mat-step>

                      <mat-step label="Conditions">
                        <div class="step-container d-flex align-items-start flex-column">
                          <div class="container-fluid">
                            <fieldset class="mt-6" *ngIf="showDays">
                              <legend class="contents text-sm font-semibold leading-6 text-gray-900">Which Days will you attend?</legend>
                              <div class="mt-4 space-y-4">
                                <div class="flex items-top">
                                  <input
                                    type="checkbox"
                                    formControlName="chkcity1"
                                    id="chkcity1"
                                    class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                                  <label for="chkcity1" class="ml-3 block mb-2 text-sm font-medium leading-6 text-gray-900 dark:text-white">
                                    {{ _day1 }}</label
                                  >
                                </div>

                                <div class="flex items-top">
                                  <input
                                    type="checkbox"
                                    formControlName="chkcity2"
                                    id="chkcity2"
                                    class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                                  <label for="chkcity2" class="ml-3 block mb-2 text-sm font-medium leading-6 text-gray-900 dark:text-white">
                                    {{ _day2 }}</label
                                  >
                                </div>
                              </div>
                            </fieldset>

                            <div class="row mb-6 mt-6">
                              <label for="special_wishes" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >Souhaits particuliers</label
                              >
                              <textarea
                                id="special_wishes"
                                formControlName="special_wishes"
                                rows="4"
                                class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder=""></textarea>
                            </div>

                            <div class="card bg-light mb-3 termsCard">
                              <div class="card-body">
                                <div class="form-group form-check" *ngIf="showStorno">
                                  <input type="checkbox" formControlName="storno_accepted" id="storno_accepted" class="form-check-input" />
                                  <label for="storno_accepted" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    <span *ngIf="legalHtml('exhibitor','storno') as h; else lgStornoDefault" [innerHTML]="h"></span>
                                    <ng-template #lgStornoDefault>Accept <a href="{{ linkStorno }}" target="_blank">Cancellation Terms</a></ng-template>
                                  </label>
                                  <div *ngIf="submitted && firstExhibitorForm.controls['storno_accepted'].invalid" class="error">
                                    Accept Cancellation Terms is required
                                  </div>
                                </div>

                                <div class="form-group form-check" *ngIf="showDSGVO">
                                  <input type="checkbox" formControlName="dsgvo_accepted" id="dsgvo_accepted" class="form-check-input" />
                                  <label for="dsgvo_accepted" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    <span *ngIf="legalHtml('exhibitor','dsgvo') as h; else lgDsgvoDefault" [innerHTML]="h"></span>
                                    <ng-template #lgDsgvoDefault>Accept <a href="{{ linkDSGVO }}" target="_blank">General Data Protection Regulation (GDPR)</a></ng-template>
                                  </label>
                                  <div *ngIf="submitted && firstExhibitorForm.controls['dsgvo_accepted'].invalid" class="error">
                                    Accept General Data Protection Regulation is required
                                  </div>
                                </div>

                                <div class="form-group form-check" *ngIf="_showTerms">
                                  <input type="checkbox" formControlName="agb_accepted" id="agb_accepted" class="form-check-input" />
                                  <label for="agb_accepted" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    <span *ngIf="legalHtml('exhibitor','terms') as h; else lgTermsDefault" [innerHTML]="h"></span>
                                    <ng-template #lgTermsDefault>Accept <a href="{{ linkTerms }}" target="_blank">Terms & Conditions</a></ng-template>
                                  </label>
                                  <div *ngIf="submitted && firstExhibitorForm.controls['agb_accepted'].invalid" class="error">
                                    Accept Terms & Conditions is required
                                  </div>
                                </div>

                                <div class="form-group form-check" *ngIf="showMedia">
                                  <input type="checkbox" formControlName="media_accepted" id="media_accepted" class="form-check-input" />
                                  <label for="media_accepted" class="block mb-2 text-sm text-gray-900 dark:text-white">
                                    <div *ngIf="legalHtml('exhibitor','media') as h; else lgMediaDefault" [innerHTML]="h"></div>
                                    <ng-template #lgMediaDefault>
                                    <div>
                                      I authorize Atout France to use the photographs taken, films shot and any recordings on which I
                                      appear, on a non-commercial basis and for the entire world, including sea and air space, on the Site,
                                      the Atout France websites (france. fr and www.atout-france.fr), social networks (Facebook, Twitter,
                                      Instagram, YouTube, LinkedIn) and other promotional media of Atout France for the promotion of the
                                      Workshop and any future editions, for a period of two(2) years from October 16, 2024.
                                    </div>
                                    </ng-template>
                                  </label>
                                  <div *ngIf="submitted && firstExhibitorForm.controls['media_accepted'].invalid" class="error">
                                    Accept Media Agreement is required
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div *ngIf="submitted && firstExhibitorForm.invalid" class="error">Please check the mandatory fields.</div>
                        <p>&nbsp;</p>
                        <div class="step-footer">
                          <button mat-raised-button matStepperPrevious>Back</button> &nbsp;
                          <button mat-raised-button (click)="submitFirststart()" color="primary">Submit</button>
                        </div>
                      </mat-step>

                      <ng-template matStepperIcon="done">
                        <mat-icon>done</mat-icon>
                      </ng-template>
                      <ng-template matStepperIcon="edit">
                        <mat-icon>no icon</mat-icon>
                      </ng-template>
                      <ng-template matStepperIcon="number">
                        <mat-icon>no icon</mat-icon>
                      </ng-template>
                    </mat-horizontal-stepper>
                  </form>
                </div>
              </mat-tab>

              <!-- ---------------------------------------- REGISTER SUCCESS ------------------------------------ -->

              <mat-tab label="Successful Registration">
                <div class="example-large-box">
                  <!-- Heading -->
                  <h1 class="mb-0 text-center">Successful Registration</h1>

                  <!-- Text -->
                  <p class="mb-6 text-center text-muted">
                    Thank you for registering to {{ __txt_subline }}. <br />
                    As soon as we review your data we send you the invitation.
                  </p>

                  <button mat-button type="button" (click)="goLogin()">back</button>
                </div>
              </mat-tab>

              <!-- end tabs -->
            </mat-tab-group>
          </div>
        </div>
        <!-- / .row -->
      </div>
    </section>
  </div>
</section>
